import styled from '@emotion/styled';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import Stack from '@mui/material/Stack';

type FormButtonsProps = {
  disabled?: boolean;
  onSave: () => unknown;
  onCancel: () => unknown;
};

export const FormButtons = (props: FormButtonsProps) => {

  return (
    <Stack direction="row" spacing={1}>
      <IconButton
        size='small'
        onClick={props.onSave}
        disabled={props.disabled}>
        <CheckButton />
      </IconButton>
      <IconButton
        size='small'
        onClick={props.onCancel}>
        <CloseButton />
      </IconButton>
    </Stack>
  );
};

const CloseButton = styled(CloseIcon)(({ theme }) => ({
  color: 'var(--pri-04)',
}));
const CheckButton = styled(CheckIcon)(({ theme }) => ({
  color: 'var(--pri-03)',
}));